import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/finance/lib/Financial_workspaceCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
